<template>

    <div>

        <vue-dropzone
            :ref="reference"
            :id="reference"
            :include-styling="true"
            :options="dzOptions"
            :destroyDropzone="true"
            v-on:vdropzone-sending="dzSending"
            v-on:vdropzone-mounted="dzInit"
            v-on:vdropzone-error="dzError"
            v-on:vdropzone-success="dzSuccess"
            :class="type == 'button' ? 'buttonDropzone' : ''">

        </vue-dropzone>

        <!-- MODAL WINDOW -->
        <modal class="loadingSpinner" :show-ok="false" :show-cancel="false" :backdrop-closable="false" :is-show="showLoadingSpinner" @close="showLoadingSpinner=false">

            <div class="has-text-centered">
                <loading-indicator></loading-indicator>
            </div>

        </modal>


    </div>

</template>



<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {

    components: {
        vueDropzone
    },

    props: {

        reference: {
            type: [String, Number],
            default: 'vueDropzone'
        },
        url: {
            type: String,
            default: '',
            required: true
        },
        thumbnailWidth: {
            type: Number,
            default: 150
        },
        thumbnailHeight: {
            type: Number,
            default: 65
        },
        acceptedFiles: {
            type: String,
            default: null
        },
        maxFileSizeInMB: {
            type: Number,
            default: 100
        },
        maxNumberOfFiles: {
            type: Number,
            default: 15
        },
        type: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ""
        },
        iconClass: {
            type: String,
            default: 'fa fa-cloud-upload'
        },
        showIcon: {
            type: Boolean,
            default: true,
        }

    },

    data () {
        return {

            showLoadingSpinner: false,
            refreshIntervalId: null,
            progressStatus: null,

            dzOptions: {
				url: '',
				headers: {
					"Cache-Control": "",
					"X-Requested-With": "",
					"Authorization": 'Basic ' + localStorage.getItem('token')
				},
				dictDefaultMessage: '',
				dictCancelUpload: 'x',
				dictRemoveFile: 'x',
				thumbnailWidth: '145',
				thumbnailHeight: '67',
				maxFileSizeInMB: '100',
				maxNumberOfFiles: '5',
				showRemoveLink: true,
				addRemoveLinks: true
			},

        }
    },


    created() {

        // this.showLoadingSpinner = true;
        this.dzOptions.url = this.url;

        let icon = "";

        if(this.showIcon) {
            icon = "<i class='"+this.iconClass+"'></i>";
            if(this.type == "button") {
                icon = "<span class='icon is-normal'>"+icon+"</span>";
            }
        }

        if(this.acceptedFiles != null) {
            this.dzOptions.acceptedFiles = this.acceptedFiles;
        }

        this.dzOptions.dictDefaultMessage = icon + this.label;

    },

    methods: {

        dzInit() {


        },

        dzSending() {

            this.showLoadingSpinner = true;

        },

        dzSuccess(file, response) {

            if(!response.taskLogId) {

                this.showLoadingSpinner = false;
                this.$notify.success({content: "Die Datei wurde erfolgreich hochgeladen!"});

            }

            else {

                let taskLogId = response.taskLogId;
                var self = this;

                this.refreshIntervalId = setInterval(function() {

                    self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                        .then(function(response) {

                            self.progressStatus = response.data;

                            if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                clearInterval(self.refreshIntervalId);

                                self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                // self.closeModal();
                                self.showLoadingSpinner = false;

                            }

                        });

                }.bind(self), 1000);


                setTimeout(() =>{

                    clearInterval(this.refreshIntervalId);
                    // self.showModal = false;
                    this.showLoadingSpinner = false;

                }, 100000);

            }

        },

        dzError(response) {

            this.showLoadingSpinner = false;
            this.$notify.warning({content: 'Beim Hochladen der Datei trat ein Fehler auf: ' + response.xhr.responseText });

        },

    }


}
</script>



<style lang="scss">


    .buttonDropzone {

        min-height: 80px !important;
        border: none !important;
        border-radius: 3px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        background: #475465 !important;
        transition: all .3s ease;
        cursor: pointer;

        &:hover {
            background: #353e4b !important;
        }
        /*
        &:after {
            content: "Nachtdienste hochladen";
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            text-transform: uppercase;
            color: #eee;
            font-size: 12px;
            border-radius: 3px;
        }
        */

        .dz-message {

            margin: 0 auto;
            text-align: center;
            text-transform: uppercase;
            color: #eee;
            font-size: 12px;
            display: block !important;

            .icon {
                margin: 0 auto 8px auto !important;
                display: block;
            }

        }


        .dz-preview {
            height: 50px;
            min-height: 50px;
            margin: 0;
            display: none;

            .dz-error-mark,
            .dz-success-mark {
                margin-left: auto!important;
                margin-top: auto!important;
                width: 100% !important;
                left: 0;
                top: 0 !important;
            }

            .dz-error-mark i {
                font-size: 100%;
            }
            .dz-default.dz-message i {
                font-size: 2rem;
            }
        }
    }


</style>

<style>
    
    .modal.loadingSpinner {
        justify-content: center !important;
        align-items: center !important;
    }
    .modal.loadingSpinner .modal-card {
        margin: 0;
        box-shadow: none !important;
    }
    .modal.loadingSpinner .modal-card-body {
        background: none !important;
    }

    .modal.loadingSpinner .modal-card-head,
    .modal.loadingSpinner .modal-card-foot {
        display: none !important;
    }


</style>
